import { render } from "./TemplateBuilder.vue?vue&type=template&id=71593c8e&scoped=true"
import script from "./TemplateBuilder.vue?vue&type=script&lang=js"
export * from "./TemplateBuilder.vue?vue&type=script&lang=js"

import "./TemplateBuilder.vue?vue&type=style&index=0&id=71593c8e&scoped=true&lang=scss"
import "./TemplateBuilder.vue?vue&type=style&index=1&id=71593c8e&lang=scss"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71593c8e"]])

export default __exports__